var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#9C4E21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 17.3333H20.6666V8.16667H7.33325V17.3333ZM14.8333 19V20.6667H18.1666V22.3333H9.83325V20.6667H13.1666V19H6.49325C6.38382 18.9993 6.2756 18.9771 6.17478 18.9345C6.07397 18.892 5.98254 18.83 5.90574 18.752C5.82895 18.674 5.76829 18.5817 5.72725 18.4802C5.68621 18.3788 5.6656 18.2703 5.66658 18.1608V7.33917C5.66658 6.87583 6.04575 6.5 6.49325 6.5H21.5066C21.9633 6.5 22.3333 6.87417 22.3333 7.33917V18.1608C22.3333 18.6242 21.9541 19 21.5066 19H14.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/Career.eecd3ce47527486e0b1af851fb917787.svg";
export { ForwardRef as ReactComponent };